exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clone-tree-panel[data-v-96d2b3fa]{background:#f8f9fa}.clone-tree-item[data-v-96d2b3fa]{font-size:.9rem}", ""]);

// exports
